import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'orderShouldBeRepeated',
  standalone: true,
})
export class OrderShouldBeRepeatedPipe implements PipeTransform {
  public transform = (value: string): boolean => ['RNoValidationQuote', 'RNotEnoughQuantity', 'RNotEnoughBuyingPwr'].indexOf(value) > -1;
}
